<template>
  <div class="app-wrapper">
    <header class="main-header d-flex align-items-center justify-between px-3 py-2 w-100">
      <!-- Left side -->
      <div class="d-flex align-items-center gap-2">
        <BackHome />
      </div>

      <!-- Right side -->
      <div class="ms-auto">
        <SignInStatus @open-login="loginModalOpen = true" />
      </div>
    </header>


    <main class="main-content">
      <div class="container animated">
        <router-view />
      </div>
    </main>

    <MainFooter />
    <MainNotification />

    <VersionChecker />
    <EnablePush />

    <Waves />
    <LoginModal :visible="loginModalOpen" @close="loginModalOpen = false" :allowSignup="true" :allowEmailLogin="true" />
  </div>
</template>

<script setup>
  import { onMounted, computed, watch, provide, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { useHead } from '@vueuse/head'
  import { useAuthStore, VersionChecker, EnablePush, uiState, patchFetch, SignInStatus, LoginModal } from 'shared-vue'
  const loginModalOpen = ref(false)
  provide('uiState', uiState)

  import MainNotification from './components/Parts/MainNotification.vue'
  import Waves from './components/Parts/Waves.vue'
  import BackHome from './components/Parts/MenuButton.vue'
  import MainFooter from './components/Parts/MainFooter.vue'
  
  patchFetch();

  // Route and auth
  const route = useRoute()
  const authStore = useAuthStore()

  const user = computed(() => authStore.user)
  const isAdmin = computed(() => user.value?.roles?.includes('Admin'))
  const canonicalUrl = computed(() => window.location.origin + route.path)

  // Head object (only created once inside setup)
  const headEntry = useHead({
    title: '',
    meta: [],
    link: []
  })

  // Meta tag patching logic (updates on route change)
  watch(
    () => route.fullPath,
    () => {
      var routeName = route.name ?? 'Home';
      const title = `${routeName} - TANM - Takeaway near me`
      const description =
        route.meta.description ||
        'Order your favourite food fast with TANM – the easiest way to find and track local takeaways near you. Real-time updates, secure checkout, no fuss.'

      headEntry.patch({
        title,
        meta: [
          { name: 'description', content: description },
          { property: 'og:type', content: 'website' },
          { property: 'og:title', content: route.meta.title || 'Tanm - Takeaway near me' },
          { property: 'og:description', content: description },
          { property: 'og:url', content: canonicalUrl.value },
          { property: 'og:image', content: `${window.location.origin}/tanmlogo.PNG` }
        ],
        link: [{ rel: 'canonical', href: canonicalUrl.value }]
      })
    },
    { immediate: true }
  )

  // Load user on mount
  onMounted(() => {
    authStore.fetchUser()
  })
</script>
<style scoped>
  .app-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .main-header {
    padding-left: 15em;
    min-height: 70px;
  }
</style>
